"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _md = _interopRequireDefault(require("md5"));

var _sparkMd = _interopRequireDefault(require("spark-md5"));

/* eslint-disable promise/avoid-new */
var MAX_CONCURRENT_FILE_READINGS = 10;
var currentReadingCount = 0;
var fileReadingQueue = [];

function releaseTurn() {
  if (fileReadingQueue.length > 0) {
    fileReadingQueue[0]();
    fileReadingQueue.shift();
  } else {
    currentReadingCount -= 1;
  }
}

function waitForTurn() {
  return _waitForTurn.apply(this, arguments);
}

function _waitForTurn() {
  _waitForTurn = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", new _promise["default"](function (resolve, reject) {
              if (currentReadingCount < MAX_CONCURRENT_FILE_READINGS) {
                currentReadingCount += 1;
                resolve();
              } else {
                fileReadingQueue.push(resolve);
              }
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _waitForTurn.apply(this, arguments);
}

var FileReaderWriterWrapper = /*#__PURE__*/function () {
  function FileReaderWriterWrapper() {
    (0, _classCallCheck2["default"])(this, FileReaderWriterWrapper);
  }

  (0, _createClass2["default"])(FileReaderWriterWrapper, null, [{
    key: "readFileAsText",
    value: function () {
      var _readFileAsText = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(fileEntry) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return waitForTurn();

              case 2:
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  fileEntry.file(function (file) {
                    var reader = new window.FileReader();

                    reader.onloadend = function () {
                      releaseTurn();
                      resolve(reader.result);
                    };

                    reader.readAsText(file, 'UTF-8');
                  }, function (error) {
                    console.error('failed getting file from fileEntry', fileEntry);
                    releaseTurn();
                    reject(error);
                  });
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function readFileAsText(_x) {
        return _readFileAsText.apply(this, arguments);
      }

      return readFileAsText;
    }()
  }, {
    key: "readFileAsBytes",
    value: function () {
      var _readFileAsBytes = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fileEntry) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return waitForTurn();

              case 2:
                return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                  fileEntry.file(function (file) {
                    var reader = new window.FileReader();

                    reader.onloadend = function () {
                      releaseTurn();
                      resolve(reader.result);
                    };

                    reader.readAsArrayBuffer(file);
                  }, function (error) {
                    console.error('failed getting file from fileEntry', fileEntry);
                    releaseTurn();
                    reject(error);
                  });
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function readFileAsBytes(_x2) {
        return _readFileAsBytes.apply(this, arguments);
      }

      return readFileAsBytes;
    }()
    /**
     * Parallel loading of up to 10 files. If more are required, they are added to a queue
     */

  }, {
    key: "readFileAsDataUrl",
    value: function () {
      var _readFileAsDataUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(fileEntry) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return waitForTurn();

              case 2:
                return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                  fileEntry.file(function (file) {
                    var reader = new window.FileReader();

                    reader.onloadend = function () {
                      releaseTurn();
                      resolve(reader.result);
                    };

                    reader.readAsDataURL(file);
                  }, function (error) {
                    console.error('failed getting file from fileEntry', fileEntry);
                    releaseTurn();
                    reject(error);
                  });
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function readFileAsDataUrl(_x3) {
        return _readFileAsDataUrl.apply(this, arguments);
      }

      return readFileAsDataUrl;
    }()
    /**
     * Works for text.
     *
     * Check yourself if it also works for binary data. Once you know, write down your findings right here where this
     * doc is written, please.
     */

  }, {
    key: "writeToFile",
    value: function () {
      var _writeToFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(fileEntry, data) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return waitForTurn();

              case 2:
                return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function () {
                      releaseTurn();
                      resolve(fileEntry.toURL());
                    };

                    fileWriter.onerror = function (error) {
                      releaseTurn();
                      reject(error);
                    };

                    fileWriter.write(data);
                  });
                }));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function writeToFile(_x4, _x5) {
        return _writeToFile.apply(this, arguments);
      }

      return writeToFile;
    }()
  }, {
    key: "getMd5Hash",
    value: function () {
      var _getMd5Hash = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(fileEntry) {
        var string, arrayBuffer;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(fileEntry.name.indexOf('json') !== -1)) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 3;
                return FileReaderWriterWrapper.readFileAsText(fileEntry);

              case 3:
                string = _context5.sent;
                return _context5.abrupt("return", FileReaderWriterWrapper.getMd5(string));

              case 7:
                _context5.next = 9;
                return FileReaderWriterWrapper.readFileAsBytes(fileEntry);

              case 9:
                arrayBuffer = _context5.sent;
                return _context5.abrupt("return", FileReaderWriterWrapper.getMd5HashFromArrayBuffer(arrayBuffer));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getMd5Hash(_x6) {
        return _getMd5Hash.apply(this, arguments);
      }

      return getMd5Hash;
    }()
  }, {
    key: "getMd5HashFromArrayBuffer",
    value: function getMd5HashFromArrayBuffer(arrayBuffer) {
      var spark = new _sparkMd["default"].ArrayBuffer();
      spark.append(arrayBuffer);
      return spark.end();
    }
  }, {
    key: "getMd5",
    value: function () {
      var _getMd = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(string) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", (0, _md["default"])(string));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getMd5(_x7) {
        return _getMd.apply(this, arguments);
      }

      return getMd5;
    }() // alg = SHA-1, SHA-256, SHA-384, SHA-512

  }, {
    key: "getSHAHash",
    value: function () {
      var _getSHAHash = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(string, alg) {
        var msgUint8, hashBuffer, hashArray;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                msgUint8 = new TextEncoder().encode(string); // encode as (utf-8) Uint8Array

                _context7.next = 3;
                return window.crypto.subtle.digest(alg, msgUint8);

              case 3:
                hashBuffer = _context7.sent;
                // hash the message
                hashArray = (0, _from["default"])(new Uint8Array(hashBuffer)); // convert buffer to byte array

                return _context7.abrupt("return", hashArray.map(function (b) {
                  return b.toString(16).padStart(2, '0');
                }).join(''));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getSHAHash(_x8, _x9) {
        return _getSHAHash.apply(this, arguments);
      }

      return getSHAHash;
    }()
  }]);
  return FileReaderWriterWrapper;
}();

var _default = FileReaderWriterWrapper;
exports["default"] = _default;